<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="
      t('common.paramDates', { param: t('manifests.manifests'), count: 1 })
    "
    class="manifest-date-filter w-3"
    help-text="mm/dd/yyyy hh:mm"
    optional
  >
    <DateRangeFilter
      :id="inputId"
      v-model="internalValue.manifestDate"
      :placeholder="
        t('common.paramDates', { param: t('manifests.manifests'), count: 1 })
      "
      append-to="body"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ManifestSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import DateRangeFilter from '@rygen/rygen-ui/components/search/DateRangeFilter.vue';

const internalValue = defineModel({
  type: Object as PropType<ManifestSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();
</script>
